import { Button, Modal, notification } from 'antd';
import React, { useEffect, useState } from 'react'
import ViewFiles from './viewFiles';
import { NuInput } from '../../../../Components/Utils/Input';
import EditIcon from '../../../../Components/Icons/Edit';
import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import * as yup from 'yup';


const EditComments = ({ data, taskId, getData, clientTickViewId }) => {
    const [open, setOpen] = useState(false);
    const [api, contextHolder] = notification.useNotification();
  
    const [image, setImage] = useState([]);
    const [selectedFile, setSelectedFile] = useState([]);
    const [filePathList, setFilePathList] = useState([]);
    const [removeFilePathList, setRemoveFilePathList] = useState([]);
  
    const [createNew, setCreateNew] = useState({
      mainId: clientTickViewId,
      comments: '',
      files: '',
    });
  
    useEffect(() => {
      if (data) {
        setCreateNew({
          mainId: clientTickViewId,
          comments: data?.comments || '',
        });
  
        if (
          data.attachments !== null &&
          data.attachments !== 'None' &&
          data.attachments !== '[]'
        ) {
          setFilePathList(data.attachments);
          setRemoveFilePathList(data.attachments);
        }
      }
    }, [data, clientTickViewId]);
  
    const onCancel = () => {
      setOpen(false);
    };
  
    const handleImageChange = (e) => {
      const maxFileSize = 200 * 1024 * 1024; // 200 MB
      const selectedFiles = Array.from(e.target.files);
      let validFiles = [];
      let previewUrls = [];
  
      selectedFiles.forEach((file) => {
        if (file.size < maxFileSize) {
          validFiles.push(file);
          previewUrls.push(URL.createObjectURL(file));
        } else {
          api.warning({
            message: `File Size Too Big`,
            description: `${file.name} is removed and not uploaded`,
            placement: 'bottomRight',
          });
        }
      });
  
      setSelectedFile(validFiles);
      setImage(previewUrls);
    };
  
    const UpdateAttachmentList = (item) => {
      const updatedList = filePathList.filter((file) => file !== item);
      setFilePathList(updatedList);
    };
  
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validationSchema: yup.object({
        comments: yup.string().required('Enter the Comment'),
      }),
      validateOnChange: false,
      validateOnBlur: false,
      onSubmit: async (value, { resetForm }) => {
        // const formData = new FormData();
        // formData.append('json_data', JSON.stringify(value));
  
        // selectedFile.forEach((file) => {
        //   formData.append('attachments', file);
        // });
  
        axiosInstance
          .put(`/task-comments/${data?.id}`, value)
          .then((res) => {
            if (res.status === 200 || res.status === 201) {
              resetForm();
              setImage([]);
              setSelectedFile([]);
              getData();
              onCancel();
              api.success({
                message: 'Comment updated successfully',
                placement: 'bottomRight',
              });
            } else {
              api.error({
                message: 'Comment update failed',
                description: res.data.msg || 'Network error',
                placement: 'bottomRight',
              });
            }
          })
          .catch((err) => {
            api.error({
              message: 'Comment update failed',
              description: err.response?.data?.msg || 'Network error',
              placement: 'bottomRight',
            });
          });
      },
    });
  
    return (
      <>
        <span
          className="mr-2 flex justify-center items-center cursor-pointer"
          onClick={() => setOpen(true)}
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <EditIcon color='blue' height={12}/>
          </svg>
        </span>
  
        <Modal
          open={open}
          title={data ? 'Edit Comment' : 'Create Comment'}
          width="45%"
          className="my-modal"
          centered
          onCancel={onCancel}
          footer={[]}
        >
          {contextHolder}
          <form onSubmit={formik.handleSubmit}>
            <NuInput
              type="text"
              label="Task Comment"
              placeholder="Write A Comment"
              formik={formik}
              name="comments"
              width="w-full"
            />
  
            <div className="w-full flex gap-2 items-center mt-2 flex-wrap">
              {filePathList &&
                filePathList.map((file, idx) => (
                  <div
                    className="w-28 h-11 relative flex justify-center items-center rounded-lg"
                    key={idx}
                    style={{ border: '1px solid gray' }}
                  >
                    <div
                      className="w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center -top-2 -right-2 z-10"
                      onClick={() => UpdateAttachmentList(file)}
                    >
                      x
                    </div>
                    <div className="w-28 h-11 flex justify-center items-center rounded-lg overflow-hidden">
                      <ViewFiles data={file} />
                    </div>
                  </div>
                ))}
  
              {/* <Attachement
                handleChange={handleImageChange}
                preview={image}
                width="w-full"
                label="Attach"
                multiple={true}
              /> */}
            </div>
  
            <div className="w-full flex justify-end items-center mt-4">
              <Button onClick={onCancel} className="mr-4">
                Cancel
              </Button>
              <Button
                htmlType="submit"
                className="bg-mainColor-500"
                type="primary"
              >
                Submit
              </Button>
            </div>
          </form>
        </Modal>
      </>
    );
  };
  

export default EditComments